import React from 'react'
import '../../App.css'
import '../index.css'
import Footer from '../Footer'
import MenuItems from '../MenuItems'

export default function Services() {
  return (
    <>
      <MenuItems />
      <Footer />
    </>
  )
}
